import type { DocumentPageMetadataUserEditEntry } from 'features/knowledgeDocumentViewer/types/documentMetadataUserEditSchemas'

const PAGE_ID_PAGE_NUM_RE = /_pg_(\d+)$/

function isConfirmedOverlayEvent(
  edit: DocumentPageMetadataUserEditEntry
): boolean {
  return edit.entry.data.status !== 'deferred'
}

function overlayEventTime(edit: DocumentPageMetadataUserEditEntry): number {
  const raw = edit.entry.created_at ?? edit.entry.updated_at
  if (!raw) return 0
  const ms = Date.parse(raw)
  return Number.isFinite(ms) ? ms : 0
}

export function pageMetadataUserEditPageNum(
  edit: DocumentPageMetadataUserEditEntry
): number | undefined {
  const pageNum = edit.entry.data.page_num
  if (typeof pageNum === 'number' && Number.isFinite(pageNum)) {
    return pageNum
  }
  const match = PAGE_ID_PAGE_NUM_RE.exec(edit.entry.data.page_id)
  if (!match?.[1]) return undefined
  const parsed = Number(match[1])
  return Number.isFinite(parsed) ? parsed : undefined
}

/** Latest confirmed page user-edit; missing status counts as confirmed. */
export function selectLatestConfirmedPageMetadataUserEdit(
  edits: readonly DocumentPageMetadataUserEditEntry[]
): DocumentPageMetadataUserEditEntry | undefined {
  let winner: DocumentPageMetadataUserEditEntry | undefined
  let winnerTime = Number.NEGATIVE_INFINITY
  for (const edit of edits) {
    if (!isConfirmedOverlayEvent(edit)) continue
    const time = overlayEventTime(edit)
    if (winner === undefined || time > winnerTime) {
      winner = edit
      winnerTime = time
    }
  }
  return winner
}

export function latestConfirmedPageUserEditForPage(
  edits: readonly DocumentPageMetadataUserEditEntry[],
  documentId: string,
  pageNum: number
): DocumentPageMetadataUserEditEntry | undefined {
  return selectLatestConfirmedPageMetadataUserEdit(
    edits.filter(
      (edit) =>
        edit.entry.data.document_id === documentId &&
        pageMetadataUserEditPageNum(edit) === pageNum
    )
  )
}
